const Utils = {
    getUrlArg(name) {
        // var after = 'code=001osmFa1BJ7UD075jGa1Qjern4osmFQ&state=STATE&code=07128g0w3qeteZ2MSD0w3OV1bR228g0p&state=STATE#/codelogin'
        var after = window.location.search.split('?')[1]
        if (after) {
            var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
            var r = after.match(reg)
            if (r != null) {
                return decodeURIComponent(r[2])
            } else {
                return null
            }
        }
    },
    // 手机号规则
    telPattern(tel) {
        let pattern = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
        let result = pattern.test(tel)
        console.log(result)
        return result
    },
    // 姓名规则
    namePattern(name) {
        let pattern = /[A-Za-z\u4e00-\u9fa5]+/
        let result = pattern.test(name)
        return result
    },
    // 身份证规则
    identityPattern(identity) {
        let pattern = /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}[0-9Xx]$)/
        let result = pattern.test(identity)
        return result
    },
    // 去除空格
    noSpace(str) {
        return str.replace(/\s+/g, '')
    },
    // 是否微信端
    isweixin() {
        var rst = true
        if (
            window.navigator.userAgent.match(
                /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
            )
        ) {
            var ua = navigator.userAgent.toLowerCase()
            if (!(ua.match(/MicroMessenger/i) == 'micromessenger')) {
                rst = false
            }
        } else {
            rst = false
        }
        return rst
        // var ua = window.navigator.userAgent.toLowerCase()
        // if (ua.match(/MicroMessenger/i) === 'micromessenger') {
        //     return true
        // } else {
        //     return false
        // }
    },
    // 手机type
    phoneType() {
        var u = navigator.userAgent
        var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 // android终端
        var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
        return {
            isAndroid: isAndroid,
            isiOS: isiOS
        }
    },
    // 身份证获取年龄
    getAgeByIdentity(identityCard) {
        var len = (identityCard + '').length
        if (len === 0) {
            return 0
        } else {
            // 身份证号码只能为15位或18位其它不合法
            if (len !== 15 && len !== 18) {
                return 0
            }
        }
        var strBirthday = ''
        // 处理18位的身份证号码从号码中得到生日和性别代码
        if (len === 18) {
            strBirthday =
                identityCard.substr(6, 4) + '/' + identityCard.substr(10, 2) + '/' + identityCard.substr(12, 2)
        }
        if (len === 15) {
            strBirthday =
                '19' + identityCard.substr(6, 2) + '/' + identityCard.substr(8, 2) + '/' + identityCard.substr(10, 2)
        }
        // 时间字符串里，必须是“/”
        var birthDate = new Date(strBirthday)
        var nowDateTime = new Date()
        var age = nowDateTime.getFullYear() - birthDate.getFullYear()
        // 再考虑月、天的因素;.getMonth()获取的是从0开始的，这里进行比较，不需要加1
        if (
            nowDateTime.getMonth() < birthDate.getMonth() ||
            (nowDateTime.getMonth() === birthDate.getMonth() && nowDateTime.getDate() < birthDate.getDate())
        ) {
            age--
        }
        return age
    },
    // 图片
    // base64获取后缀
    dataURLSuffix(dataurl) {
        let arr = dataurl.split(',')
        let mime = arr[0].match(/:(.*?);/)[1]
        let fileExt = mime.split('/')[1]
        return fileExt
    },
    dataURLtoFile(dataurl, filename) {
        var arr = dataurl.split(',')
        var mime = arr[0].match(/:(.*?);/)[1]
        var fileExt = mime.split('/')[1]
        var bstr = atob(arr[1])
        var n = bstr.length
        var u8arr = new Uint8Array(n)
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n)
        }
        return new File([u8arr], filename + '.' + fileExt, {
            type: mime
        })
    },
    // 生成随机字符串
    generateRandomAlphaNum(len) {
        var rdmString = ''
        for (
            ;
            rdmString.length < len;
            rdmString += Math.random()
                .toString(36)
                .substr(2)
        );
        return rdmString.substr(0, len)
    },
    // 收益格式化
    profitFormat(number, decimals, decPoint, thousandsSep) {
        /*
         * 参数说明：
         * number：要格式化的数字
         * decimals：保留几位小数
         * decPoint：小数点符号
         * thousandsSep：千分位符号
         * */
        number = (number + '').replace(/[^0-9+-Ee.]/g, '')
        var n = !isFinite(+number) ? 0 : +number
        var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
        var sep = typeof thousandsSep === 'undefined' ? ',' : thousandsSep
        var dec = typeof decPoint === 'undefined' ? '.' : decPoint
        var s = ''
        var toFixedFix = function(n, prec) {
            var k = Math.pow(10, prec)
            return '' + Math.ceil(n * k) / k
        }

        s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.')
        var re = /(-?\d+)(\d{3})/
        while (re.test(s[0])) {
            s[0] = s[0].replace(re, '$1' + sep + '$2')
        }
        if ((s[1] || '').length < prec) {
            s[1] = s[1] || ''
            s[1] += new Array(prec - s[1].length + 1).join('0')
        }
        return s.join(dec)
    },
    // 获取链接上的参数
    getParams() {
        var sStr = window.location.href
        var params = {}
        var pattern = /(\w+)=([^&#]*)*/g
        var arr = sStr.match(pattern)
        if (arr) {
            for (var i = 0; i < arr.length; i++) {
                var kv = arr[i].split('=')
                params[kv[0]] = kv[1]
            }
        }
        return params
    },
    // 格式化数字输入
    changeNum(val) {
        // 如果用户第一位输入的是小数点，则重置输入框内容
        if (val !== '' && val.substr(0, 1) === '.') {
            val = ''
        }
        val = val.replace(/^0*(0\.|[1-9])/, '$1') // 粘贴不生效
        val = val.replace(/[^\d.]/g, '') // 清除“数字”和“.”以外的字符
        val = val.replace(/\.{2,}/g, '.') // 只保留第一个. 清除多余的
        val = val
            .replace('.', '$#$')
            .replace(/\./g, '')
            .replace('$#$', '.')
        val = val.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3') // 只能输入两个小数
        if (val.indexOf('.') < 0 && val !== '') {
            // 以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
            if (val.substr(0, 1) === '0' && val.length === 2) {
                val = val.substr(1, val.length)
            }
        }
        return val
    },
    // 数组去重
    distinct(arr) {
        let obj = {}
        let newArr = []
        for (let i = 0; i < arr.length; i++) {
            if (!obj[arr[i]]) {
                obj[arr[i]] = 1
                newArr.push(arr[i])
            }
        }
        return newArr
    },
    // 随机16位
    random16() {
        let str = ''
        let rex = '0123456789ABCDEF'
        let length = rex.length
        rex.split('').forEach((v, i) => {
            let r = Math.floor(Math.random() * (length - 1))
            str += rex[r]
        })
        return str
    }
}

export default Utils
